import React, { useEffect, useRef } from "react";

function QuestionPaypal(props) {
  const paypal = useRef();

  useEffect(() => {
    window.paypal
      .Buttons({
        createOrder: (data, actions, err) => {
          return actions.order.create({
            intent: "CAPTURE",
            purchase_units: [
              {
                description: "Question Fee",
                amount: {
                  currency_code: "USD",
                  value: props.price,
                },
              },
            ],
          });
        },
        onApprove: async (data, actions) => {
          const order = await actions.order.capture();
          props.completeQuestionPayment(order);
        },
        onError: (err) => {
          console.log(err);
        },
      })
      .render(paypal.current);
  }, []);
  return (
    <>
      <div ref={paypal} className="width-res"></div>
    </>
  );
}

export default QuestionPaypal;
